import { Component } from "react"

/* Components */
import { InnerLayout, Avatar } from "../../components"

/* REST API */
import { statistics, periodStatistics } from "../../api/Player"

/* Chart */
import { AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Area, ResponsiveContainer } from "recharts"

/* Helpers */
import { utils, datetime } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* DatePicker Settings */
registerLocale("ru", ru)



/* Widget Information */
class Information extends Component {

    constructor(props) {
        super(props)

        const date = datetime.getStatisticsDate("day")

        this.state = {
            information: null,
            status: "loading",
            tab: "",

            filter: "all",
            start: date.start,
            end: date.end,
            statistics: null,
            chart: [],
            waiting: false,

            picker: false,
            pickerStart: new Date(),
            pickerEnd: new Date(),
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load action */
    load = (reload = false) => {

        /* Fields */
        const { player } = this.props

        /* Reload Page */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        statistics({ player }).then((response) => {
            if (response.status === 200) {

                const information = response.data
                this.setState({ status: "ok", information })

                if (information.games && Array.isArray(information.games) && information.games.length > 0) {
                    this.gameLoad(information.games[0].game)
                }

            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", information: null })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", information: null })
            }
            else {
                this.setState({ status: "error", information: null })
            }
        }).catch(() => {
            this.setState({ status: "network", information: null })
        })

    }


    /* Load By Game */
    gameLoad = (game) => {

        /* Fields */
        const { scrollToTop } = this.props

        /* Save Game */
        this.setState({ tab: game })

        /* Scroll to top */
        scrollToTop()

        /* Load Statistics */
        this.setState({ filter: "all" })
    }


    /* DRAW INFORMATION WIDGET */
    _information = () => {

        /* Fields */
        const { information } = this.state
        const { ava } = this.props

        return (
            <div className="player-information-widget">

                {/* Player */}
                <div className="player-information-widget-user" >
                    <Avatar uri={utils.ava(ava, information.information.isTester && "test")} size={40} />
                    <div className="player-information-widget-user-text">
                        <div className="player-information-widget-user-code">{parseInt(information.information.isTester) > 0 ? t("player.isTester") : t("player.player")}</div>
                        <div className="player-information-widget-user-name">{utils.checkValue(information.information.firstName, "-")}</div>
                        <div className="player-information-widget-user-code">{utils.checkValue(information.information.player, "-")}</div>
                    </div>
                </div>

                {/* Games Count */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/casino.png" alt="Casino" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">{t("player.operator")}</div>
                        <div className="player-information-widget-element-value">{utils.checkValue(information.information.operator, "0")}</div>
                    </div>
                </div>

                {/* Games Count */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/spades.png" alt="Spades" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">{t("player.rounds")}</div>
                        <div className="player-information-widget-element-value">{utils.checkValue(information.analytic.rounds, "0")}</div>
                    </div>
                </div>

                {/* AVG ANTE */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/poker-chip.png" alt="Poker Chip" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">{t("player.avgBet")}</div>
                        <div className="player-information-widget-element-value">{utils.convertor(utils.checkValue(information.analytic.bet, 0), "$")}</div>
                    </div>
                </div>

                {/* Total Time */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/back-in-time.png" alt="Time" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">{t("player.totalTime")}</div>
                        <div className="player-information-widget-element-value">{utils.converTime(information.time)}</div>
                    </div>
                </div>

                {/* Debit */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/increase.png" alt="Increase" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">Debit</div>
                        <div className="player-information-widget-element-value">{utils.convertor(utils.checkValue(information.analytic.debit, 0), "$")}</div>
                    </div>
                </div>

                {/* Credit */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/decrease.png" alt="Decrease" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">Credit</div>
                        <div className="player-information-widget-element-value">{utils.convertor(utils.checkValue(information.analytic.credit, 0), "$")}</div>
                    </div>
                </div>

                {/* Total */}
                <div className="player-information-widget-element" >
                    <img src="/images/player/calculate.png" alt="Calculate" />
                    <div className="player-information-widget-element-text">
                        <div className="player-information-widget-element-name">TOTAL</div>
                        <div className={`player-information-widget-element-value ${parseFloat(information.analytic.total) > 0 && "green"} ${parseFloat(information.analytic.total) < 0 && "red"}`}>
                            {parseFloat(information.analytic.total) > 0 && "+ "}
                            {parseFloat(information.analytic.total) < 0 && "- "}
                            {utils.convertor(Math.abs(information.analytic.total), "$")}
                        </div>
                    </div>
                </div>

            </div>
        )
    }


    /* DRAW TABS */
    _tabs = () => {

        /* FIELDS */
        const { information, tab } = this.state

        return (
            <div className="player-information-games-tabs">
                {information.games.map((item, index) =>
                    <div onClick={() => this.gameLoad(item.game)} className={`player-information-games-tab ${tab === item.game ? "active" : "disabled"}`} key={`${index}`}>

                        <div className="player-information-games-tab-name">{utils.checkValue(item.name, "")}</div>

                        <div className="player-information-games-tab-row">
                            <div className="player-information-games-tab-inner">
                                <img src="/images/player/increase.png" alt="Increase" />
                                <div className="player-information-games-tab-value">+ {utils.convertor(item.debit, "$")}</div>
                            </div>
                            <div className="player-information-games-tab-inner">
                                <img src="/images/player/decrease.png" alt="Decrease" />
                                <div className="player-information-games-tab-value">- {utils.convertor(item.credit, "$")}</div>
                            </div>
                        </div>

                        <div className="player-information-games-tab-inner">
                            <img src="/images/player/calculate.png" alt="Calculate" />
                            <div className={`player-information-games-tab-value ${parseFloat(item.total) > 0 && "green"} ${parseFloat(item.total) < 0 && "red"}`}>
                                {parseFloat(item.total) > 0 && "+ "}
                                {parseFloat(item.total) < 0 && "- "}
                                {utils.convertor(Math.abs(item.total), "$")}
                            </div>
                        </div>

                    </div>
                )}

            </div>
        )
    }


    /* Load Statistics Date */
    getStatistics = () => {

        /* Fields */
        const { player } = this.props
        const { filter, start, end, tab } = this.state

        /* Check All Period */
        if (filter === "all") {
            this.setState({ waiting: false, chart: [], statistics: null })
            return
        }

        /* Start Loading */
        this.setState({ waiting: true, chart: [], statistics: null })

        /* Get Generated Dates */
        const dates = datetime.generateDates(filter, start, end)

        /* Load Statistics */
        periodStatistics({ player, game: tab, start, end, dates }).then((response) => {
            if (response.status === 200) {
                this.setState({ waiting: false, statistics: response.data.statistics, chart: response.data.chart })
            }
        })
    }


    /* Set Filter */
    setFilter = (type) => {

        const { filter } = this.state

        if (type === "period") {
            this.setState({ picker: true })
            return
        }

        if (filter !== type) {
            const date = datetime.getStatisticsDate(type)
            this.setState({ filter: type, start: date.start, end: date.end }, () => this.getStatistics())
        }
    }

    /* Go action */
    go = (type) => {

        /* Filter */
        const { filter, start, end } = this.state
        const date = datetime.setStatisticsDate(type, filter, start, end)

        if (filter === "day" || filter === "week" || filter === "month") {
            if (date) {
                this.setState({ start: date.start, end: date.end }, () => this.getStatistics())
            }
        }
    }

    /* Type Formatter */
    formatter = (value, name) => {

        if (name === "debit") {
            return [<div className="similar-text">{utils.convertor(value, "$")}</div>, "DEBIT"]
        }

        if (name === "credit") {
            return [<div className="similar-text">{utils.convertor(value, "$")}</div>, "Credit"]
        }

    }


    /* DRAW CHART */
    _chart = () => {

        const { filter, waiting, chart } = this.state

        /* Only Day Filters */
        if (filter === "day" || filter === "week" || filter === "month") {
            return (
                <div className="player-information-chart">
                    <div className="chart-content-statistics-container-inner">
                        <ResponsiveContainer>
                            <AreaChart data={chart} margin={{ left: -20, right: 30 }} style={{ opacity: waiting ? 0.8 : 1 }}>
                                <defs>
                                    <linearGradient id="colorRed" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#f44336" stopOpacity={0.1} />
                                        <stop offset="95%" stopColor="#f44336" stopOpacity={0.2} />
                                    </linearGradient>
                                    <linearGradient id="colorGreen" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#74c70a" stopOpacity={0.8} />
                                        <stop offset="95%" stopColor="#74c70a" stopOpacity={1} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="2 2" />
                                <XAxis dataKey="name" tick={{ stroke: "#141414", strokeWidth: 0.2, fontSize: 10 }} />
                                <YAxis color="#fff" tick={{ stroke: "#141414", strokeWidth: 0.2, fontSize: 12 }} />
                                <Tooltip formatter={(value, name) => this.formatter(value, name)} />
                                <Area type="monotone" dataKey="credit" stroke="#f44336" strokeWidth={2} fill="url(#colorRed)" />
                                <Area type="monotone" dataKey="debit" stroke="#74c70a" strokeWidth={2} fill="url(#colorGreen)" />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>

                </div>
            )
        }
    }


    /* Apply Picker */
    applyPicker = () => {

        /* Fields */
        const { pickerStart, pickerEnd } = this.state

        if (pickerStart && pickerStart.length === 19 && pickerEnd && pickerEnd.length === 19) {
            this.setState({ picker: false, start: pickerStart, end: pickerEnd, filter: "period" }, () => this.getStatistics())
        }
    }

    /* Draw Picker Modal */
    _picker = () => {

        /* Fields */
        const { picker, pickerStart, pickerEnd } = this.state

        return (
            <Modal
                isOpen={picker}
                onRequestClose={() => this.setState({ picker: false })}
                className="player--view-picker-modal"
                overlayClassName="player--view-picker-overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="player--view-picker-header">
                    <h2>{t("player.selectPeriod")}</h2>
                    <div onClick={() => this.setState({ picker: false })} className="player--view-picker-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Content */}
                <div className="player--view-picker-body">

                    <DatePicker
                        selected={pickerStart}
                        onChange={(date) => this.setState({ pickerStart: moment(date).format("YYYY-MM-DD 00:00:00") })}
                        selectsStart
                        startDate={pickerStart}
                        endDate={pickerEnd}
                        dateFormat="dd-MM-yyyy"
                        locale="ru"
                        placeholderText="00-00-0000"
                    />

                    <DatePicker
                        selected={pickerEnd}
                        onChange={(date) => this.setState({ pickerEnd: moment(date).format("YYYY-MM-DD 00:00:00") })}
                        selectsEnd
                        startDate={pickerStart}
                        endDate={pickerEnd}
                        minDate={pickerStart}
                        dateFormat="dd-MM-yyyy"
                        locale="ru"
                        placeholderText="00-00-0000"
                    />

                </div>

                {/* Draw Bottom */}
                <div className="player--view-picker-bottom">
                    <div onClick={() => this.applyPicker()} className="player--view-picker-apply-button">{t("filter.apply")}</div>
                </div>

            </Modal >
        )
    }

    /* DRAW CHART */
    _content = () => {

        /* Fields */
        const { information, tab, filter, start, end, statistics, waiting } = this.state

        /* Find Tab */
        const index = information.games.findIndex((e) => e.game === tab)

        /* Check Index */
        if (index > -1) {

            /* Get Current Data */
            const data = information.games[index]
            const current = filter === "all" ? data : statistics

            return (
                <div className="player-content">

                    {/* GAME NAME */}
                    <div className="player-content-title">{data.name}</div>

                    {/* CHART HEAD */}
                    <div className="player-content-statistics-head">
                        <div className="player-content-statistics-head-filter">
                            <div onClick={() => this.setFilter("all")} className={`player-content-statistics-head-filter-item ${filter === "all" ? "active" : "disabled"}`}>{t("player.statsAll")}</div>
                            <div onClick={() => this.setFilter("day")} className={`player-content-statistics-head-filter-item ${filter === "day" ? "active" : "disabled"}`}>{t("player.statsDay")}</div>
                            <div onClick={() => this.setFilter("week")} className={`player-content-statistics-head-filter-item ${filter === "week" ? "active" : "disabled"}`}>{t("player.statsWeek")}</div>
                            <div onClick={() => this.setFilter("month")} className={`player-content-statistics-head-filter-item ${filter === "month" ? "active" : "disabled"}`}>{t("player.statsMonth")}</div>
                            <div onClick={() => this.setFilter("period")} className={`player-content-statistics-head-filter-item ${filter === "period" ? "active" : "disabled"}`}>{t("player.statsPeriod")}</div>
                        </div>
                    </div>

                    {/* DASHBOARD CHART FILTER */}
                    <div className="player-content-statistics-filter">
                        <div onClick={() => this.go("prev")} className={`player-content-statistics-filter-prev ${filter === "day" || filter === "week" || filter === "month" ? "active" : "disabled"}`}>
                            <img src="/images/left-arrow.png" alt="Left" />
                        </div>
                        <div className="player-content-statistics-filter-value">{datetime.modifyDate(filter, start, end)}</div>
                        <div onClick={() => this.go("next")} className={`player-content-statistics-filter-next ${filter === "day" || filter === "week" || filter === "month" ? "active" : "disabled"}`}>
                            <img src="/images/right-arrow.png" alt="Right" />
                        </div>
                    </div>

                    {/* WIDGET */}
                    <div className={`player-content-widget ${waiting ? "loading" : "default"}`}>

                        {/* Loading */}
                        {waiting && <LoadingOutlined />}

                        {/* DEDIT */}
                        {current &&
                            <div className="player-content-widget-box">
                                <img src="/images/player/increase.png" alt="Increase" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">DEBIT</div>
                                    <div className="player-content-widget-value">+ {utils.convertor(current.debit, "$")}</div>
                                </div>
                            </div>
                        }

                        {/* CREDIT */}
                        {current &&

                            <div className="player-content-widget-box">
                                <img src="/images/player/decrease.png" alt="Decrease" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">CREDIT</div>
                                    <div className="player-content-widget-value">- {utils.convertor(current.credit, "$")}</div>
                                </div>
                            </div>
                        }

                        {/* TOTAL */}
                        {current &&

                            <div className="player-content-widget-box">
                                <img src="/images/player/calculate.png" alt="Calculate" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">TOTAL</div>
                                    <div className={`player-content-widget-value ${parseFloat(current.total) > 0 && "green"} ${parseFloat(current.total) < 0 && "red"}`}>
                                        {parseFloat(current.total) > 0 && "+ "}
                                        {parseFloat(current.total) < 0 && "- "}
                                        {utils.convertor(Math.abs(current.total), "$")}
                                    </div>
                                </div>
                            </div>
                        }

                        {/* Games Count */}
                        {current &&
                            <div className="player-content-widget-box">
                                <img src="/images/player/spades.png" alt="Spades" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">{t("player.rounds")}</div>
                                    <div className="player-content-widget-value">{utils.checkValue(current.rounds, "0")}</div>
                                </div>
                            </div>
                        }

                        {/* Avg ANTE */}
                        {current &&
                            <div className="player-content-widget-box">
                                <img src="/images/player/poker-chip.png" alt="Poker Chip" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">{t("player.avgBet")}</div>
                                    <div className="player-content-widget-value">{utils.convertor(current.bet, "$")}</div>
                                </div>
                            </div>
                        }

                        {/* Total Time */}
                        {current &&
                            <div className="player-content-widget-box">
                                <img src="/images/player/back-in-time.png" alt="Time" />
                                <div className="player-content-widget-text">
                                    <div className="player-content-widget-title">{t("player.totalTime")}</div>
                                    <div className="player-content-widget-value">{utils.converTime(current.time)}</div>
                                </div>
                            </div>
                        }

                    </div>

                    {/* DRAW CHART */}
                    {this._chart()}

                </div>
            )
        }

    }


    render = () => {

        const { status, information } = this.state

        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="player-information">

                {/* INFORMATION WIDGET */}
                {this._information()}

                {/* Games */}
                {information.games && Array.isArray(information.games) && information.games.length > 0 &&
                    <div className="player-information-games">

                        {/* GAME TABS */}
                        {this._tabs()}

                        {/* GAME CONTENT */}
                        {this._content()}

                    </div>
                }

                {/* DATE PICKER */}
                {this._picker()}

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Information)